import React, { useState } from 'react';
import { generateCurl, generateAxios, generatePython } from '../utils/codeGenerators';

const CodeExample = ({ endpoint, isDarkMode = false }) => {
  const [activeTab, setActiveTab] = useState('curl');
  const [copied, setCopied] = useState(false);

  const codeExamples = {
    curl: generateCurl(endpoint),
    axios: generateAxios(endpoint),
    python: generatePython(endpoint),
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(codeExamples[activeTab]);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="mt-6">
      <div className="flex items-center justify-between mb-2">
        <div className={`flex space-x-1 p-1 rounded-lg ${isDarkMode ? 'bg-slate-800 border border-slate-700' : 'bg-gray-100'}`}>
          <button
            onClick={() => setActiveTab('curl')}
            className={`px-3 py-1.5 text-sm font-medium rounded-md transition-colors ${
              activeTab === 'curl'
                ? isDarkMode 
                  ? 'bg-slate-700 text-slate-100 shadow-sm' 
                  : 'bg-white text-gray-900 shadow-sm'
                : isDarkMode
                  ? 'text-slate-400 hover:text-slate-200 hover:bg-slate-750'
                  : 'text-gray-600 hover:text-gray-900'
            }`}
          >
            cURL
          </button>
          <button
            onClick={() => setActiveTab('axios')}
            className={`px-3 py-1.5 text-sm font-medium rounded-md transition-colors ${
              activeTab === 'axios'
                ? isDarkMode 
                  ? 'bg-slate-700 text-slate-100 shadow-sm' 
                  : 'bg-white text-gray-900 shadow-sm'
                : isDarkMode
                  ? 'text-slate-400 hover:text-slate-200 hover:bg-slate-750'
                  : 'text-gray-600 hover:text-gray-900'
            }`}
          >
            Axios
          </button>
          <button
            onClick={() => setActiveTab('python')}
            className={`px-3 py-1.5 text-sm font-medium rounded-md transition-colors ${
              activeTab === 'python'
                ? isDarkMode 
                  ? 'bg-slate-700 text-slate-100 shadow-sm' 
                  : 'bg-white text-gray-900 shadow-sm'
                : isDarkMode
                  ? 'text-slate-400 hover:text-slate-200 hover:bg-slate-750'
                  : 'text-gray-600 hover:text-gray-900'
            }`}
          >
            Python
          </button>
        </div>
        
        <button
          onClick={handleCopy}
          className={`px-3 py-1.5 text-sm font-medium rounded-md transition-colors ${
            isDarkMode 
              ? 'text-slate-400 hover:text-slate-200 bg-slate-800 hover:bg-slate-700 border border-slate-700' 
              : 'text-gray-600 hover:text-gray-900 bg-gray-100 hover:bg-gray-200'
          }`}
        >
          {copied ? (
            <span className="flex items-center">
              <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
              Copied!
            </span>
          ) : (
            <span className="flex items-center">
              <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
              </svg>
              Copy
            </span>
          )}
        </button>
      </div>
      
      <div className={`rounded-lg p-4 overflow-x-auto ${
        isDarkMode 
          ? 'bg-slate-900 border border-slate-700' 
          : 'bg-gray-900'
      }`}>
        <pre className={`text-sm ${
          isDarkMode 
            ? 'text-slate-200' 
            : 'text-gray-300'
        }`}>
          <code>{codeExamples[activeTab]}</code>
        </pre>
      </div>
    </div>
  );
};

export default CodeExample;
